import {Grid2, Typography} from "@mui/material";
import * as React from "react";
import {color_green} from "@/agentur/AgenturColors";
import {BulletSvg, CustomerSvg} from "@/pages/landing-page/utils/Svgs";
import {Section3DTO} from "@/pages/landing-page/landing-page-data";
import {compactValue} from "@/lib/screen-class";
import {LANDING_BODY_LARGE, LANDING_HEADLINE} from "@/pages/landing-page/utils/landing-font-sizes";
import {COMPACT_SECTION_MIN_HEIGHT} from "@/pages/landing-page/utils/landing-section-layout";

interface Section3Props {
    data: Section3DTO;
}

export const Section3 = ({ data }: Section3Props) => (
        <Grid2
            container
            direction="column"
            paddingTop={4}
            width="100%"
            sx={{
                minHeight: COMPACT_SECTION_MIN_HEIGHT,
                // backgroundColor: color_grey[4],
                position: "relative",
                px: {
                    md: 1,
                    lg: 10
                }
            }}
        >
            <Grid2 width="100%">
                <Typography
                    sx={{ fontSize: LANDING_HEADLINE }}
                    fontWeight="700"
                    paddingBottom={2}
                    maxWidth="fit-content"
                    borderBottom={`3px solid ${color_green[2]}`}
                >
                    {data.title}
                </Typography>
            </Grid2>
            <Grid2
                container
                direction="row"
                flexGrow={1}
                sx={{
                    paddingTop: {
                        xs: 2,
                        md: 16
                    },
                    // The desktop gap from `lg` only: between `md` and `lg` it pushed the list below the graphic.
                    gap: {
                        xs: 8,
                        lg: 30
                    }
                }}
            >
                <Grid2
                    minWidth="228px"
                    container
                    flexGrow={1}
                    sx={{
                        justifyContent: {
                            xs: "center",
                            md: "start"
                        },
                        maxWidth: {
                            xs: "100%",
                            md: "228px"
                        },
                        px: {
                            xs: 0,
                            md: 10
                        }
                    }}
                >
                    <Grid2>
                        <CustomerSvg width="228px" />
                    </Grid2>
                </Grid2>
                <Grid2 container direction="column" gap={4}>
                    {data.bulletPoints.map((text) => (
                        <Grid2
                            key={text}
                            container
                            direction="row"
                            gap={compactValue(2, 8)}
                            flexWrap="nowrap"
                            alignItems="center"
                            width="100%"
                        >
                            {/* A long text would otherwise squeeze the icon and run over it. */}
                            <Grid2 height="64px" flexShrink={0}>
                                <BulletSvg />
                            </Grid2>
                            <Grid2>
                                <Typography sx={{ fontSize: LANDING_BODY_LARGE }} fontWeight="700">
                                    {text}
                                </Typography>
                            </Grid2>
                        </Grid2>
                    ))}
                </Grid2>
            </Grid2>
        </Grid2>
    );
